var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import * as React from 'react';
import OnClickOutside from 'react-onclickoutside';
import isEmail from 'validator/lib/isEmail';
import { Autocomplete } from '../util/autocomplete';
import styles from './AutocompleteUserAsync.module.scss';
import { isKeyToCloseDropdownInWindow } from './utils/dropdown';
class AutocompleteUserAsync extends React.Component {
    constructor(props) {
        super(props);
        this.input = React.createRef();
        this.state = {
            value: '',
            isResultShown: false,
            highlightedIndex: null,
        };
        this.onChangeInput = this.onChangeInput.bind(this);
        this.cleanPaste = this.cleanPaste.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.resetValue = this.resetValue.bind(this);
        this.focusNext = this.focusNext.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyDownHandling = this.onKeyDownHandling.bind(this);
        this.getImmediate = this.getImmediate.bind(this);
        this.autocomplete = new Autocomplete(this.getImmediate);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        // If `users` has changed we want to reset `highlightedIndex`
        // since it probably no longer refers to a relevant item.
        //
        // The entries in `users` may have been changed even though the
        // object reference remains the same, double check by seeing
        // if `highlightedIndex` points to an existing item.
        let emailUsers = [];
        let nextEmailUsers = [];
        if (this.props.elements.length > 0) {
            emailUsers = this.props.elements.filter((user) => typeof user.email === 'string' && user.email !== '');
        }
        if (nextProps.elements.length > 0) {
            nextEmailUsers = nextProps.elements.filter((user) => typeof user.email === 'string' && user.email !== '');
        }
        if (emailUsers !== nextEmailUsers ||
            this.state.highlightedIndex >= nextEmailUsers.length) {
            this.setState({ highlightedIndex: null, emailUsers: nextEmailUsers });
        }
        else {
            this.setState({ emailUsers: nextEmailUsers });
        }
    }
    handleWindowKeydown(event) {
        if (isKeyToCloseDropdownInWindow(event.key) && !!this.getRequesters()) {
            event.stopPropagation();
            this.handleClickOutside();
        }
    }
    componentDidMount() {
        window.addEventListener('keydown', this.handleWindowKeydown);
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleWindowKeydown);
    }
    componentDidUpdate(prevProps, prevState) {
        if (!prevState.isResultShown &&
            this.state.isResultShown &&
            this.input.current) {
            this.input.current.focus();
        }
    }
    handleClickOutside() {
        this.setState({ isResultShown: false }, () => {
            if (this.state.value.trim() === '') {
                this.resetValue();
            }
        });
    }
    resetValue() {
        this.setState({ value: '', highlightedIndex: null });
    }
    getImmediate(searchValue) {
        return this.props.getfunction(searchValue);
    }
    onChangeInput(e) {
        // Prevent multiple spaces
        const value = e.target.value.replace(/\s\s+/g, ' ');
        this.setState({ value, isResultShown: true }, () => {
            this.autocomplete.search(value);
        });
    }
    focusNext() {
        if (this.input.current) {
            this.input.current.focus();
        }
    }
    onBlur() {
        // Validate the value as a valid email.
        if (isEmail(this.state.value) === true) {
            const email = this.state.value;
            let found = false;
            // Loop our already selected fields.
            this.props.fields.map((field, index) => {
                const f = this.props.fields.get(index);
                // Match emails to see if we need to add first.
                //console.warn("match", f.user.email, email)
                if (f.user.email.toLowerCase() === email.toLowerCase()) {
                    found = true;
                }
            });
            if (found === false) {
                // Async search the API to replace our input with API user.
                this.getImmediate(email)
                    .then((r) => {
                    var _a;
                    //console.warn("response: ", r.data );
                    if (Array.isArray(r.data) &&
                        (r.data.length === 0 ||
                            // Add additional check to support v2/search
                            ((_a = r.data[0].hits) === null || _a === void 0 ? void 0 : _a.length) === 0)) {
                        this.props.add({ user: { id: null, email } });
                        this.resetValue();
                    }
                    else if (Array.isArray(r.data) &&
                        r.data[0].hits &&
                        Array.isArray(r.data[0].hits) &&
                        r.data[0].hits.length > 0) {
                        // It could be one of these.
                        let foundUser = false;
                        for (const user of r.data[0].hits) {
                            if (user.email &&
                                user.email.toLowerCase() === email.toLowerCase()) {
                                this.props.add({ user: user });
                                foundUser = true;
                                this.resetValue();
                                break;
                            }
                        }
                        if (foundUser === false) {
                            this.props.add({ user: { id: null, email: email } });
                            this.resetValue();
                        }
                    }
                    else {
                        console.error('We did receive something unexpected from the API.', r);
                    }
                })
                    .catch((e) => {
                    console.error('Exception: ', e);
                });
            }
            else {
                console.info('onBlur email is ALREADY in selected', email);
            }
        }
        else {
            console.info('onBlur value is a NOT valid email', this.state.value, this.props.stopFormSubmit);
            if (this.props.stopFormSubmit) {
                this.props.stopFormSubmit(this.props.formName, {
                    _errors: 'Not valid email',
                });
            }
        }
    }
    onKeyDownHandling(e) {
        if (e.which === 13) {
            e.preventDefault();
            let user = null;
            const numberOfOptions = this.props.elements.length;
            if (this.state.highlightedIndex !== null) {
                user = this.props.elements[this.state.highlightedIndex];
            }
            else if (numberOfOptions === 1) {
                user = this.props.elements[0];
            }
            if (user) {
                this.props.add({ user: user });
                this.setState({
                    value: '',
                    isResultShown: false,
                    highlightedIndex: null,
                });
            }
        }
        else if (e.which === 40) {
            // Arrow down.
            e.preventDefault();
            const numberOfOptions = this.props.elements.length;
            if (!numberOfOptions) {
                return;
            }
            const highlightedIndex = this.state.highlightedIndex;
            const index = highlightedIndex === null || highlightedIndex === numberOfOptions - 1
                ? 0
                : highlightedIndex + 1;
            this.setState({ highlightedIndex: index });
        }
        else if (e.which === 38) {
            // Arrow up.
            e.preventDefault();
            const numberOfOptions = this.props.elements.length;
            if (!numberOfOptions) {
                return;
            }
            const highlightedIndex = this.state.highlightedIndex;
            const index = highlightedIndex === 0 || highlightedIndex === null
                ? numberOfOptions - 1
                : highlightedIndex - 1;
            this.setState({ highlightedIndex: index });
        }
    }
    cleanPaste(e) {
        if (e.clipboardData && typeof e.clipboardData.getData === 'function') {
            e.preventDefault();
            const text = e.clipboardData
                .getData('text/plain')
                .trim()
                .replace(/(?:\r\n|\r|\n)/g, '');
            this.onChangeInput({
                target: { value: text },
            });
        }
        else {
            this.onChangeInput(e);
        }
    }
    getRequesters() {
        const { elements, status, ElementItem, add } = this.props;
        const { value } = this.state;
        let requesters;
        const listUsers = (user, index) => {
            let highlighted = false;
            if (this.state.highlightedIndex === index) {
                highlighted = true;
            }
            if (user.email !== undefined &&
                user.email !== null &&
                typeof user.email === 'string' &&
                user.email.trim() !== '') {
                return (_jsx(ElementItem
                // Duplicates has same ids, add index to prevent duplicate keys
                , { add: add, user: user, highlighted: highlighted, resetValue: this.resetValue, closeDropDown: this.handleClickOutside }, user.id + user.duplicate ? index : ''));
            }
            return null;
        };
        if (status === 'loading') {
            // We are fetching the elements.
            requesters = (_jsx("div", Object.assign({ className: "row-item empty-list text-center" }, { children: "Loading..." })));
        }
        else if (elements.length === 0 &&
            status === 'succeeded' &&
            value.length >= 2 &&
            isEmail(value) === true) {
            requesters = null;
        }
        else if (elements.length === 0 &&
            status === 'succeeded' &&
            value.length >= 2) {
            requesters = (_jsx("div", Object.assign({ className: "row-item empty-list text-center" }, { children: "No user found" })));
        }
        else if (status === 'failed') {
            requesters = (_jsx("div", Object.assign({ className: "row-item empty-list text-center" }, { children: "Error while fetching" })));
        }
        else if (elements.length > 0 && value.length > 1) {
            requesters = elements.map(listUsers);
        }
        else if (status === 'succeeded' && value.length === 0) {
            requesters = null;
        }
        else if (value.length > 0) {
            requesters = null;
        }
        return requesters;
    }
    render() {
        const { fields, formName, onFocusFunction, onBlurFunction, placeholder, numberOfResults, } = this.props;
        const { value, isResultShown } = this.state;
        const requesters = this.getRequesters();
        return (_jsxs("div", Object.assign({ className: classnames('user-search-wrapper', {
                hidden: this.props.isShown === false,
            }) }, { children: [_jsx("textarea", { id: "autocomplete-user", ref: this.input, className: classnames(styles.emailForm, 'form-control user-search'), spellCheck: "false", autoComplete: "new-password", onKeyDown: this.onKeyDownHandling, onFocus: (e) => {
                        this.setState({ isResultShown: true });
                        if (onFocusFunction && typeof onFocusFunction === 'function') {
                            onFocusFunction(e);
                        }
                    }, onBlur: (e) => {
                        this.onBlur();
                        this.props.touch(formName, fields.name);
                        if (onBlurFunction && typeof onBlurFunction === 'function') {
                            onBlurFunction(e);
                        }
                    }, onPaste: this.cleanPaste, placeholder: placeholder, onChange: this.onChangeInput, value: value }), _jsx("div", Object.assign({ className: `dropdown-result-list user-list ${isResultShown ? '' : 'hidden'}`, role: "menu", "aria-expanded": isResultShown && !!requesters }, { children: requesters })), value.length >= 2 && isResultShown && numberOfResults > 0 && (_jsx("div", Object.assign({ className: styles.numberOfResults }, { children: `${numberOfResults} ${numberOfResults === 1 ? 'result' : 'results'}` })))] })));
    }
}
__decorate([
    boundMethod
], AutocompleteUserAsync.prototype, "handleWindowKeydown", null);
export default OnClickOutside(AutocompleteUserAsync);
